export default "__VITE_ASSET__DMLa1$iJ__"